export default {
  setMessages (state, messages) {
    state.messages = messages
  },

  setMessage (state, message) {
    state.message = message
  },

  setUser (state, user) {
    state.user = user
  },

  setContent (state, content) {
    state.content = content
  }
}
